import { initFederation } from '@angular-architects/native-federation';
// The manifest store's own entry point, not the nf-remote barrel: the barrel also exports Angular
// components, and shared externals like @angular/core only resolve once initFederation below has
// written the import map — main.ts runs before that.
import { fetchFederationManifest, setFederationManifest } from '@comparit/nf-remote/manifest';
import type { FederationManifest } from '@comparit/nf-remote/manifest';
import { ENDKUNDE_MOUNT_PATH } from './app/endkunde-mount';

// The public Endkunde form uses only workspace libs — no sparte remotes. Init federation with an
// empty manifest on that path so it never fetches the remoteEntry.json files; the normal app loads
// the full manifest. (The shared-dependency scope is still set up either way.)
const isEndkunde = window.location.pathname.toLowerCase().startsWith(`/${ENDKUNDE_MOUNT_PATH}/`);

// Fetched here instead of by initFederation so the routes can look a remote's remoteEntry url up
// later: a remote that was unreachable at boot is then registered on its first navigation instead
// of staying unknown for the life of the tab (see loadSparteModule).
(isEndkunde ? Promise.resolve<FederationManifest>({}) : fetchFederationManifest())
  .then(
    manifest => {
      setFederationManifest(manifest);
      return initFederation(manifest);
    },
    err => {
      // Boot without remotes rather than not at all. The manifest store stays unset, so the first
      // sparte load fetches the file again — the tab is not dead for its whole life.
      console.error('federation.manifest.json could not be loaded', err);
      return initFederation({});
    }
  )
  .catch(err => console.error(err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
